import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { PrimaryButton } from '@photosi/rn-components/buttons/primary-button/PrimaryButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { TestIDs } from 'src/constants/testIDs.constants';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { useCallback, useEffect, useState } from 'react';
import { DYNAMIC_MODAL_VIEWS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { text, alert } from 'src/theme/colors';
import { TextIconButton } from '@photosi/rn-components/buttons/text-icon-button/TextIconButton';
import {
  TEXT_ICON_BUTTON_SIZES,
  TEXT_ICON_BUTTON_TYPES,
} from '@photosi/rn-components/buttons/text-icon-button/TextIconButton.constants';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { getCorruptedFilesDescription } from 'src/_shared/utils/getCorruptedFilesDescription';

import { UploadScreenChildProps } from '../UploadScreen.types';

export type UploadAgainComponentProps = UploadScreenChildProps;

export const UploadAgainComponent = ({
  onPressUpload,
  corruptedFiles,
  title,
  description,
  ctaText,
  corruptedTitle,
  corruptedCta,
  corruptedUrlText,
  style,
}: UploadAgainComponentProps) => {
  const { i18n, data, dynamicModal } = useStore();
  const [isCorruptedScreen, setIsCorruptedScreen] = useState<boolean>(false);

  useEffect(() => {
    if (corruptedFiles.current.length > 0) {
      data.setFileListError(corruptedFiles.current);
      setIsCorruptedScreen(true);
    }
  }, [corruptedFiles, data]);

  const onPressShowErrorFiles = useCallback(() => {
    dynamicModal.openModal({
      dynamicModalView: DYNAMIC_MODAL_VIEWS.ModalUploadError,
    });
  }, [dynamicModal]);

  const currentTitle = isCorruptedScreen ? corruptedTitle : title;
  const currentCta = isCorruptedScreen ? corruptedCta : ctaText;

  return (
    <View style={style.uploadContent}>
      <View style={{ width: 56, height: 56 }}>
        <Illustration name={ILLUSTRATION_NAMES.ImportFailed} />
      </View>
      <View style={style.textWrapper}>
        <TextLato style={style.title}>{currentTitle}</TextLato>
        {isCorruptedScreen ? (
          <TextLato style={[style.text, { color: alert.alertRed }]}>
            {getCorruptedFilesDescription(i18n, corruptedFiles.current, 3)}
          </TextLato>
        ) : (
          <TextLato style={style.text}>{description}</TextLato>
        )}
      </View>
      {isCorruptedScreen && (
        <TextIconButton
          size={TEXT_ICON_BUTTON_SIZES.MEDIUM}
          type={TEXT_ICON_BUTTON_TYPES.NO_ICON}
          focusOrder={0}
          focusGroup={FocusGroups.CHOOSE_PHOTO_BANNER}
          focusId={''}
          text={corruptedUrlText}
          iconName={ICON_NAMES.AddFrame}
          onPress={async () => onPressShowErrorFiles()}
          textStyle={style.textCta}
          hoverStyle={{ textDecorationLine: 'underline', textDecorationColor: text.color.interactive } as any}
        />
      )}
      <View>
        <PrimaryButton
          style={style.button}
          onPress={onPressUpload}
          testID={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
          focusId={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
          focusOrder={0}
          focusGroup={FocusGroups.CHOOSE_PHOTO_BANNER}
          text={currentCta}
          textStyle={style.buttonText}
        />
      </View>
    </View>
  );
};

